const DATA = [
{ name: 'id', type: 'textinput', searchField: '', options:[], reference: '', nullable: true, editable: false, export: true, import: true },
{ name: 'account_id', type: 'reference', reference: 'account',searchField: 'name', nullable: false, editable: false, export: true, import: true },
{ name: 'team_id', type: 'reference', reference: 'team', searchField: 'name', nullable: false, editable: false, export: true, import: true },
{ name: 'name', type: 'textinput', nullable: false, editable: true, export: true, import: true },
{ name: 'post_code', type: 'textinput', nullable: false, editable: true, export: true, import: true },
{ name: 'pref', type: 'reference', reference: 'pref',searchField: 'name', nullable: false, editable: true, export: true, import: true },
{ name: 'city_name', type: 'textinput', nullable: false, editable: true, export: true, import: true },
{ name: 'address', type: 'textinput', nullable: false, editable: true, export: true, import: true },
{ name: 'building', type: 'textinput', nullable: true, editable: true, export: true, import: true },
{ name: 'area_name', type: 'textinput', nullable: false, editable: true, export: true, import: true },
{ name: 'search_pref_name', type: 'textinput', nullable: false, editable: true, export: true, import: true },
{ name: 'search_city_name', type: 'textinput', nullable: false, editable: true, export: true, import: true },
// line
{},
{},
{},
{},
{},
{},
{ name: 'line1', text_detail: 'text_detail_line1', type: 'textinput', nullable: true, editable: true, export: true, import: true },
//{ name: 'line_cd1', type: 'textinput', nullable: true, editable: true, export: true, import: true },
{ name: 'station1', type: 'textinput', nullable: true, editable: true, export: true, import: true },
//{ name: 'station_cd1', type: 'textinput', nullable: true, editable: true, export: true, import: true },
{ name: 'walk1', type: 'textinput', nullable: true, editable: true, export: true, import: true },
{ name: 'line2', text_detail: 'text_detail_line2', type: 'textinput', nullable: true, editable: true, export: true, import: true },
//{ name: 'line_cd2', type: 'textinput', nullable: true, editable: true, export: true, import: true },
{ name: 'station2', type: 'textinput', nullable: true, editable: true, export: true, import: true },
//{ name: 'station_cd2', type: 'textinput', nullable: true, editable: true, export: true, import: true },
{ name: 'walk2', type: 'textinput', nullable: true, editable: true, export: true, import: true },
{ name: 'line3', text_detail: 'text_detail_line3', type: 'textinput', nullable: true, editable: true, export: true, import: true },
//{ name: 'line_cd3', type: 'textinput', nullable: true, editable: true, export: true, import: true },
{ name: 'station3', type: 'textinput', nullable: true, editable: true, export: true, import: true },
//{ name: 'station_cd3', type: 'textinput', nullable: true, editable: true, export: true, import: true },
{ name: 'walk3', type: 'textinput', nullable: true, editable: true, export: true, import: true },
{ name: 'created', type: 'hidden', nullable: true, editable: false, export: true, import: true },
{ name: 'created_by', type: 'hidden', numberFormat:true,nullable: true, editable: false, export: true, import: true },
{ name: 'note', type: 'textinput', multiline: true, nullable: true, editable: true, export: true, import: true },

]

export default DATA;